enum PackRequestTypes {
  RequestPack = 1,
  RequestTrial = 2,
  RequestExtraLicenses = 3,
}

export default PackRequestTypes;
